import React from 'react';
import { Box, Flex, Link, Text } from '@chakra-ui/react';
import { FOOTER_LINKS } from '@/utils/constants';

export const GlobalFooter: React.FC = () => {
  const footerLinks = [
    { label: 'Contact', href: FOOTER_LINKS.CONTACT },
    { label: 'Terms', href: FOOTER_LINKS.TERMS },
    { label: 'Privacy', href: FOOTER_LINKS.PRIVACY },
    { label: 'Developer Docs', href: FOOTER_LINKS.DEVELOPER_DOCS },
    { label: 'System Status', href: FOOTER_LINKS.SYSTEM_STATUS },
  ];

  return (
    <Box
      as="footer"
      borderTop="1px"
      borderColor="gray.200"
      bg="gray.50"
      py={4}
      px={4}
      mt="auto"
      maxH={50}
    >
      <Flex
        direction={{ base: 'column', md: 'row' }}
        justify="space-between"
        align={{ base: 'flex-start', md: 'center' }}
        gap={{ base: 2, md: 0 }}
        maxW="full"
      >
        <Flex direction="row" justify="start" gap={6} maxW="full">
          {footerLinks.map((link, index) => (
            <Link
              key={index}
              href={link.href}
              fontSize="xs"
              color="gray.900"
              textDecoration="none"
              _hover={{ textDecoration: 'underline' }}
            >
              {link.label}
            </Link>
          ))}
        </Flex>

        {/* Copyright Row */}
        <Text fontSize="xs" color="gray.600">
          © {new Date().getFullYear()} PagerDuty, Inc. All rights reserved.
        </Text>
      </Flex>
    </Box>
  );
};

export default GlobalFooter;
